import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Modal,
  Fade,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import DPasswordInput from "../../../components/Dashboard/DashboardInputs/DPasswordInput";
import { emptyCheck, validatePassword } from "../../../utils/validations";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import { offlinePasswordRepository } from "../../../offline/repositories/offlinePassword.repository";

const ROWS_PER_PAGE = 10;

const thStyle = {
  // fontWeight: 600,
  fontSize: "16px",
  fontFamily: "gilroyBold",
};
const titleStyle = { fontSize: "18px", fontFamily: "gilroyBold" };
const tdStyle = { fontSize: "14px", fontFamily: "gilroyMedium" };

export default function ManageOfflinePassword() {
  const loginData = useSelector((state) => state.loginData.value);
  const auth_token = loginData?.auth_token;
  const [devices, setDevices] = useState([]);
  const [page, setPage] = useState(1);

  const [openEdit, setOpenEdit] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);

  const [openS, setOpenS] = useState(false);
  const handleOpenS = () => setOpenS(true);
  const handleCloseS = () => {
    setOpenS(false);
  };
  const [oldPassword, setOldPassword] = useState({
    value: "",
    isValid: true,
  });

  const [newPassword, setNewPassword] = useState({
    value: "",
    isValid: true,
  });

  const [confirmNewPassword, setConfirmNewPassword] = useState({
    value: "",
    isValid: true,
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    fetchPassword();
  }, []);

  const SettingsInputs = [
    <DPasswordInput
      key="old"
      label="Old Password"
      type="password"
      value={oldPassword.value}
      onChange={(e) => {
        let val = e.target.value;
        setOldPassword({
          value: val,
          isValid: validatePassword(val),
        });
      }}
      error={!oldPassword.isValid}
      errorMsg={
        !emptyCheck(oldPassword.value)
          ? "Old Password is required"
          : !oldPassword.isValid
            ? "Invalid password"
            : ""
      }
      size="100%"
    />,

    <DPasswordInput
      key="new"
      label="New Password"
      type="password"
      value={newPassword.value}
      onChange={(e) => {
        let val = e.target.value;
        setNewPassword({
          value: val,
          isValid: validatePassword(val),
        });
      }}
      error={!newPassword.isValid}
      errorMsg={
        !emptyCheck(newPassword.value)
          ? "New Password is required"
          : !newPassword.isValid
            ? "Invalid password"
            : ""
      }
      size="100%"
      info
    />,

    <DPasswordInput
      key="confirm"
      label="Confirm Password"
      type="password"
      onChange={(e) => {
        let val = e.target.value;
        setConfirmNewPassword({
          value: val,
          isValid: val === newPassword.value,
        });
      }}
      error={!confirmNewPassword.isValid}
      errorMsg={
        !emptyCheck(confirmNewPassword.value)
          ? "Confirm Password is required"
          : !confirmNewPassword.isValid
            ? "Password doesn't match"
            : ""
      }
      value={confirmNewPassword.value}
      confirmPassword
      comparePassword={newPassword.value}
      size="100%"
    />,
  ];
const userType =
  loginData?.access_type === "vendor admin" ||
  loginData?.access_type === "vendor contact"
    ? "vendor"
    : "organization";
  const deviceId = localStorage.getItem("device_id");
  const fetchPassword = async () => {
    try {
      const res = await axios.post(
        API_ENDPOINT.offline_password_list,
        {
          user_token: loginData.user?.user_token,
          user_type:userType,
          device_id: deviceId,
        },
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        },
      );

      setDevices((res.data?.response || []).filter((d) => d.active));
    } catch (err) {
      console.error("Fetch failed", err);
    }
  };

  const updatePassword = async () => {
    try {
      await axios.post(
        API_ENDPOINT.offline_password_update,
        {
          user_token: loginData.user?.user_token,
          device_id: selectedDevice.device_id,
          old_password: oldPassword.value,
          password: newPassword.value,
        },
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        },
      );
      //update IndexedDB immediately
      await offlinePasswordRepository.syncFromAPI(
        auth_token,
        loginData.user?.user_token,
        selectedDevice.device_id,
        userType
      );

      handleOpenS();
      setOpenEdit(false);
      fetchPassword();
    } catch (err) {
      alert("Password update failed");
      console.error(err);
    }
  };

  const paginated = devices.slice(
    (page - 1) * ROWS_PER_PAGE,
    page * ROWS_PER_PAGE,
  );

  const handleUpdate = () => {
    if (
      !emptyCheck(oldPassword.value) ||
      !emptyCheck(newPassword.value) ||
      confirmNewPassword.value !== newPassword.value
    ) {
      alert("Please fix password fields");
      return;
    }

    updatePassword();
  };

  const handleEdit = (device) => {
    setSelectedDevice(device);

    setOldPassword({ value: "", isValid: true });
    setNewPassword({ value: "", isValid: true });
    setConfirmNewPassword({ value: "", isValid: true });

    setOpenEdit(true);
  };

  return (
    <>
      {/* ---------- MOBILE VIEW ---------- */}
      {isMobile && (
        <Box sx={{ p: 1, ml: 2, mr: 2 }}>
          {paginated.length > 0 ? (
            paginated.map((row) => (
              <Paper
                key={row.device_id}
                sx={{
                  p: 2,
                  mb: 2,
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <Typography fontWeight={600}>Device ID</Typography>
                <Typography mb={1}>{row.device_id}</Typography>

                <Typography fontWeight={600}>Created Date</Typography>
                <Typography mb={1}>
                  {new Date(row.created_at).toLocaleString()}
                </Typography>

                <Box textAlign="right">
                  <IconButton onClick={() => handleEdit(row)}>
                    <EditIcon />
                  </IconButton>
                </Box>
              </Paper>
            ))
          ) : (
            <Typography textAlign="center" mt={4} sx={{ fontSize: "14px" }}>
              No devices found
            </Typography>
          )}
        </Box>
      )}

      {/* ---------- DESKTOP TABLE ---------- */}
      {!isMobile && (
        <>
          <Box sx={{ p: 2 }}>
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "700",
                py: 2,
                fontFamily: "gilroyMedium",
              }}
            >
              Manage Offline Password
            </Typography>

            <TableContainer
              component={Paper}
              sx={{
                borderRadius: 2,
                boxShadow: 2,
                overflowX: "auto",
              }}
            >
              <Table sx={{ minWidth: 900 }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "rgb(224, 233, 238)" }}>
                    <TableCell sx={thStyle}>Device ID</TableCell>
                    <TableCell sx={thStyle}>Password Created</TableCell>
                    <TableCell sx={thStyle} align="center">
                      Edit Password
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {paginated.length > 0 ? (
                    paginated.map((row) => (
                      <TableRow key={row.device_id} hover>
                        <TableCell sx={tdStyle}>{row.device_id}</TableCell>

                        <TableCell sx={tdStyle}>
                          {new Date(row.created_at).toLocaleString()}
                        </TableCell>

                        <TableCell align="center">
                          <IconButton onClick={() => handleEdit(row)}>
                            <EditIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        align="center"
                        variant="h6"
                        sx={{ py: 4, fontSize: "14px" }}
                      >
                        No devices found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      )}

      {/* edit pass */}

      <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth>
        <DialogTitle p={1} sx={titleStyle}>
          Edit Offline Password
        </DialogTitle>

        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2}>
            {/* Old Password */}
            {SettingsInputs[0]}

            {/* New + Confirm in one row */}
            <Box display="flex" gap={2}>
              <Box flex={1}>{SettingsInputs[1]}</Box>
              <Box flex={1}>{SettingsInputs[2]}</Box>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenEdit(false)} sx={thStyle}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleUpdate} style={thStyle}>
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* ---------- Pagination ---------- */}
      <TablePagination
        component="div"
        count={devices.length}
        page={page - 1}
        rowsPerPage={ROWS_PER_PAGE}
        rowsPerPageOptions={[10]}
        onPageChange={(_, newPage) => setPage(newPage + 1)}
        sx={{
          "& .MuiTablePagination-toolbar": {
            flexWrap: "wrap",
            justifyContent: "flex-end",
          },
          "& .MuiTablePagination-selectLabel, \
       & .MuiTablePagination-displayedRows, \
       & .MuiTablePagination-select": {
            fontSize: "16px",
          },
          "& .MuiIconButton-root": {
            fontSize: "16px",
          },
        }}
      />

      <Modal open={openS}>
        <Fade in={openS}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={
                <>
                  Password Changed <br /> Successfully!
                </>
              }
              // popupDescription={}
              popBtn={true}
              btnText={"Okay"}
              btnClick={handleCloseS}
            />
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
